import {
  Button,
  TextField,
  Box,
  Typography,
  Card,
  CardContent,
  CardActions,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { useLoaderData, useNavigate } from 'react-router'
import { ActivityModel } from 'types'
import axios from 'axios'
import { base_url } from 'env'
import { toast } from 'react-hot-toast'

export default function ActivityPreviewPage() {
  const navigate = useNavigate()
  const activity = useLoaderData() as ActivityModel

  const handleDelete = () => {
    if (
      window.confirm(
        `Êtes-vous sûr de vouloir supprimer l'activité "${activity.title}" ?`
      )
    ) {
      axios
        .delete(base_url + `/activity/${activity.id}`)
        .then(() => {
          toast.success('Activité supprimée avec succès.')
          navigate('/activities')
        })
        .catch((err) => {
          console.error('Failed to delete activity:', err)
        })
    }
  }

  return (
    <PageAppBar pageName={`Activité: ${activity.title}`}>
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Card sx={{ width: '100%', maxWidth: '800px' }}>
          <CardContent
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            <Typography variant="h4" component="h2" textAlign="center">
              {activity.title}
            </Typography>

            <TextField
              fullWidth
              label="ID"
              value={activity.id}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
            <TextField
              fullWidth
              multiline
              label="Instructions (Parents)"
              value={activity.instructions}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
            {activity.instructionsCloseCircle && (
              <TextField
                fullWidth
                multiline
                label="Instructions (Cercle Proche)"
                value={activity.instructionsCloseCircle}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            )}
            {activity.instructionsOther && (
              <TextField
                fullWidth
                multiline
                label="Instructions (Autre Personne)"
                value={activity.instructionsOther}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            )}
            <TextField
              fullWidth
              label="Support"
              value={activity.support}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
            <TextField
              fullWidth
              label="Catégorie"
              value={activity.category}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
            <TextField
              fullWidth
              label="Difficulté de base"
              value={activity.baseDifficulty}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
            <TextField
              fullWidth
              label="Plaisir de base"
              value={activity.basePleasure}
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
          </CardContent>
          <CardActions sx={{ p: 2, justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(`/activity/${activity.id}/edit`)
              }}
            >
              Modifier
            </Button>
            <Button variant="contained" color="error" onClick={handleDelete}>
              Supprimer
            </Button>
          </CardActions>
        </Card>
      </Box>
    </PageAppBar>
  )
}
